export function escape(str) {
    return str.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
}
//# sourceMappingURL=util.js.map